import { FC } from 'react';

import { Head } from '@inertiajs/react';

import { Metadata, StructuredData } from '../../types/shared';

type Props = {
    metadata: Metadata;
    structuredData?: StructuredData | null;
};

const serializedStructuredData = (structuredData: StructuredData): string =>
    JSON.stringify(structuredData)
        .replace(/</g, '\\u003c')
        .replace(/>/g, '\\u003e')
        .replace(/&/g, '\\u0026');

const structuredDataHeadKey = { 'head-key': 'structured-data' };

export const SeoHead: FC<Props> = ({ metadata, structuredData }) => (
    <Head>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <meta property="og:type" content={metadata.type || 'website'} />
        <meta property="og:title" content={metadata.title} />
        <meta property="og:description" content={metadata.description} />
        <meta property="og:url" content={metadata.url} />
        {metadata.siteName && (
            <meta property="og:site_name" content={metadata.siteName} />
        )}
        {metadata.imageUrl && (
            <meta property="og:image" content={metadata.imageUrl} />
        )}
        {metadata.imageUrl && metadata.imageType && (
            <meta property="og:image:type" content={metadata.imageType} />
        )}
        {metadata.imageUrl && metadata.imageWidth && (
            <meta
                property="og:image:width"
                content={String(metadata.imageWidth)}
            />
        )}
        {metadata.imageUrl && metadata.imageHeight && (
            <meta
                property="og:image:height"
                content={String(metadata.imageHeight)}
            />
        )}
        {metadata.imageUrl && metadata.imageAlt && (
            <meta property="og:image:alt" content={metadata.imageAlt} />
        )}
        {metadata.imageUrl && (
            <meta name="twitter:card" content="summary_large_image" />
        )}
        {metadata.imageUrl && (
            <meta name="twitter:title" content={metadata.title} />
        )}
        {metadata.imageUrl && (
            <meta name="twitter:description" content={metadata.description} />
        )}
        {metadata.imageUrl && (
            <meta name="twitter:image" content={metadata.imageUrl} />
        )}
        {metadata.robots && <meta name="robots" content={metadata.robots} />}
        {metadata.canonicalUrl && (
            <link rel="canonical" href={metadata.canonicalUrl} />
        )}
        {structuredData && (
            <script
                type="application/ld+json"
                {...structuredDataHeadKey}
                dangerouslySetInnerHTML={{
                    __html: serializedStructuredData(structuredData),
                }}
            />
        )}
    </Head>
);
